import { Product } from "@/types/product";
import { Blog } from "@/types/blogItem";
import { Category } from "@/types/category";
import { Author } from "@/types/author";
import { Order } from "@/types/order";
import { Countdown } from "@/types/countdown";

// Mock Authors
export const mockAuthors: Author[] = [
  {
    _id: "author-1",
    name: "Jan Kowalski",
    image: "/images/avatar.jpeg",
    bio: [
      {
        style: "normal",
        _key: "bio-1",
        markDefs: [],
        children: [
          {
            _type: "span",
            text: "Ekspert w dziedzinie e-commerce i marketingu cyfrowego.",
          },
        ],
        _type: "block",
      },
    ],
    numberOfPosts: 5,
    slug: { current: "jan-kowalski", _type: "slug" },
    description: "Ekspert w dziedzinie e-commerce i marketingu cyfrowego.",
  },
  {
    _id: "author-2",
    name: "Anna Nowak",
    image: "/images/avatar.jpeg",
    bio: [
      {
        style: "normal",
        _key: "bio-2",
        markDefs: [],
        children: [
          {
            _type: "span",
            text: "Specjalistka od designu produktów i UX.",
          },
        ],
        _type: "block",
      },
    ],
    numberOfPosts: 3,
    slug: { current: "anna-nowak", _type: "slug" },
    description: "Specjalistka od designu produktów i UX.",
  },
];

// Mock Categories
export const mockCategories: Category[] = [
  {
    _id: "cat-1",
    title: "Electronics",
    image: "/images/categories/categories-01.png",
    slug: { current: "electronics", _type: "slug" },
    description: "Najnowsza elektronika i gadżety",
    productCount: 45,
    postCount: 12,
  },
  {
    _id: "cat-2",
    title: "Fashion",
    image: "/images/categories/categories-02.png",
    slug: { current: "fashion", _type: "slug" },
    description: "Modne ubrania i akcesoria",
    productCount: 78,
    postCount: 20,
  },
  {
    _id: "cat-3",
    title: "Home & Garden",
    image: "/images/categories/categories-03.png",
    slug: { current: "home-garden", _type: "slug" },
    description: "Wszystko do domu i ogrodu",
    productCount: 32,
    postCount: 8,
  },
  {
    _id: "cat-4",
    title: "Sports",
    image: "/images/categories/categories-04.png",
    slug: { current: "sports", _type: "slug" },
    description: "Sprzęt sportowy i odzież",
    productCount: 56,
    postCount: 15,
  },
];

// Mock Products
export const mockProducts: Product[] = [];

// Mock Blog Posts
export const mockBlogPosts: Blog[] = [
  {
    _id: 1,
    title: "Najlepsze trendy w e-commerce 2024",
    slug: { current: "trendy-ecommerce-2024", _type: "slug" },
    category: "E-commerce",
    metadata: "Trendy e-commerce 2024",
    metaDescription: "Odkryj najważniejsze trendy w e-commerce na 2024 rok",
    body: [
      {
        style: "normal",
        _key: "body-1",
        markDefs: [],
        children: [
          {
            _type: "span",
            text: "E-commerce rozwija się w zawrotnym tempie. W tym artykule przedstawiamy najważniejsze trendy...",
          },
        ],
        _type: "block",
      },
    ],
    mainImage: "/images/blog/blog-1.png",
    author: mockAuthors[0],
    tags: ["ecommerce", "trends", "business"],
    publishedAt: "2024-01-15T10:00:00.000Z",
  },
  {
    _id: 2,
    title: "Jak zwiększyć konwersję w sklepie online",
    slug: { current: "zwieksz-konwersje", _type: "slug" },
    category: "Marketing",
    metadata: "Zwiększanie konwersji",
    metaDescription: "Sprawdzone metody na zwiększenie konwersji w e-commerce",
    body: [
      {
        style: "normal",
        _key: "body-2",
        markDefs: [],
        children: [
          {
            _type: "span",
            text: "Konwersja to klucz do sukcesu w e-commerce. Przedstawiamy sprawdzone metody...",
          },
        ],
        _type: "block",
      },
    ],
    mainImage: "/images/blog/blog-2.png",
    author: mockAuthors[1],
    tags: ["marketing", "conversion", "optimization"],
    publishedAt: "2024-01-20T14:30:00.000Z",
  },
  {
    _id: 3,
    title: "Design produktów - najlepsze praktyki",
    slug: { current: "design-produktow", _type: "slug" },
    category: "Design",
    metadata: "Design produktów",
    metaDescription: "Najlepsze praktyki w designie produktów cyfrowych",
    body: [
      {
        style: "normal",
        _key: "body-3",
        markDefs: [],
        children: [
          {
            _type: "span",
            text: "Dobry design to nie tylko estetyka, ale przede wszystkim użyteczność...",
          },
        ],
        _type: "block",
      },
    ],
    mainImage: "/images/blog/blog-3.png",
    author: mockAuthors[1],
    tags: ["design", "ux", "products"],
    publishedAt: "2024-02-01T09:00:00.000Z",
  },
];

// Mock Orders
export const mockOrders: Order[] = [
  {
    _id: "order-1",
    orderId: "ORD-2024-001",
    status: "completed",
    totalPrice: 549.98,
    userId: "user-1",
    quantity: 2,
    orderTitle: "Wireless Headphones + Smart Watch",
    createdAt: "2024-01-10T12:30:00.000Z",
    shippingAddress: {
      floor: "",
      street: "",
      houseNumber: "",
      apartmentNumber: "",
    },
    items: [],
    shippingZipCode: "",
    shippingCity: "",
  },
  {
    _id: "order-2",
    orderId: "ORD-2024-002",
    status: "processing",
    totalPrice: 99.99,
    userId: "user-2",
    quantity: 1,
    orderTitle: "Designer T-Shirt",
    createdAt: "2024-01-12T15:45:00.000Z",
    shippingAddress: {
      floor: "",
      street: "",
      houseNumber: "",
      apartmentNumber: "",
    },
    items: [],
    shippingZipCode: "",
    shippingCity: "",
  },
  {
    _id: "order-3",
    orderId: "ORD-2024-003",
    status: "shipped",
    totalPrice: 479.98,
    userId: "user-1",
    quantity: 2,
    orderTitle: "Running Shoes + Yoga Mat",
    createdAt: "2024-01-15T10:20:00.000Z",
    shippingAddress: {
      floor: "",
      street: "",
      houseNumber: "",
      apartmentNumber: "",
    },
    items: [],
    shippingZipCode: "",
    shippingCity: "",
  },
];

// Mock Countdown
export const mockCountdown: Countdown = {
  _id: "countdown-1",
  title: "Wielka Wyprzedaż!",
  image: "/images/countdown/countdown-01.png",
  subtitle: "Do 50% zniżki na wybrane produkty",
  date: "2024-12-31T23:59:59.000Z",
  product: {
    slug: "wireless-headphones",
    name: "Wireless Headphones",
  },
};

// Mock Hero Banners
export const mockHeroBanners = [
  {
    _id: "banner-1",
    title: "Nowa Kolekcja",
    subtitle: "Odkryj najnowsze trendy",
    image: "/images/hero/bannar-1.png",
    link: "/shop",
  },
  {
    _id: "banner-2",
    title: "Wyprzedaż",
    subtitle: "Do -50% na wybrane produkty",
    image: "/images/hero/bannar-2.png",
    link: "/shop?sale=true",
  },
];

// Mock Hero Sliders
export const mockHeroSliders = [
  {
    _id: "slider-1",
    title: "Premium Electronics",
    subtitle: "Najlepsza technologia w Twoim zasięgu",
    image: "/images/hero/slider-1.png",
    link: "/shop/electronics",
  },
  {
    _id: "slider-2",
    title: "Fashion Trends",
    subtitle: "Bądź zawsze w modzie",
    image: "/images/hero/slider-2.png",
    link: "/shop/fashion",
  },
  {
    _id: "slider-3",
    title: "Sports & Fitness",
    subtitle: "Osiągnij swoje cele",
    image: "/images/hero/slider-3.png",
    link: "/shop/sports",
  },
];

// Mock Coupons
export const mockCoupons = [
  {
    _id: "coupon-1",
    name: "Zniżka na start",
    code: "WELCOME10",
    discount: 10,
    maxRedemptions: 100,
    timesRedemed: 45,
  },
  {
    _id: "coupon-2",
    name: "Wyprzedaż letnia",
    code: "SUMMER20",
    discount: 20,
    maxRedemptions: 200,
    timesRedemed: 120,
  },
  {
    _id: "coupon-3",
    name: "Wielka promocja",
    code: "MEGA50",
    discount: 50,
    maxRedemptions: 50,
    timesRedemed: 38,
  },
];
